$(document).ready(function () {
  $('[data-toggle="ion-rangeslider"]').each(function () {
    $(this).ionRangeSlider();
  });
});
